module.exports = __webpack_public_path__ + "img/Platform_Gradients-6.213f8c5e.jpg";